import { ReactElement } from "react";
import { cn } from "@/lib/utils";

const ICON_SIZE_MAP: Record<string, number> = {
  small: 16,
  medium: 20,
  large: 29,
};
const DEFAULT_ICON_SIZE = ICON_SIZE_MAP.medium ?? 20;

const ICON_UNDERLAY_MARGIN = 4;

export interface ComponentUnderlayProps {
  children: ReactElement;
  size: number | string;
  underlayColor?: string;
  className?: string;
}

const getSizeValue = (size: ComponentUnderlayProps["size"]) => {
  if (typeof size === "number") {
    return size;
  }

  const sizeKeyValue = ICON_SIZE_MAP[size];
  if (sizeKeyValue) {
    return sizeKeyValue + ICON_UNDERLAY_MARGIN;
  }

  const numericValue = Number(String(size).replace(/\D/g, ""));
  if (!Number.isNaN(numericValue)) {
    return numericValue;
  }

  return DEFAULT_ICON_SIZE + ICON_UNDERLAY_MARGIN;
};

export const ComponentUnderlay = ({ children, underlayColor, size, className }: ComponentUnderlayProps) => {
  const computedSize = getSizeValue(size);

  return (
    <div
      data-testid="component-underlay"
      className={cn(
        "relative flex items-center justify-center rounded-full",
        !underlayColor && "bg-cede-primary/10",
        className,
      )}
      style={{
        width: `${computedSize}px`,
        height: `${computedSize}px`,
        ...(underlayColor ? { backgroundColor: underlayColor } : {}),
      }}
    >
      <div className="absolute inset-0 flex items-center justify-center">{children}</div>
    </div>
  );
};
